(function () {
  'use strict';

  var GAP = 20;

  function initCarousel(section) {
    var track = section.querySelector('[data-m2vc-track]');
    var bar = section.querySelector('[data-m2vc-bar]');
    var thumb = section.querySelector('[data-m2vc-thumb]');
    var cleanup = [];

    function on(el, ev, fn, opts) {
      el.addEventListener(ev, fn, opts);
      cleanup.push(function () { el.removeEventListener(ev, fn, opts); });
    }

    /* Cached metrics: layout is read on resize only, never on scroll. */
    var metrics = { max: 0, barW: 0, thumbW: 0 };
    var rafId = null;

    function updateAlignment() {
      if (!track) return;
      track.classList.toggle('m2vc-track--fit', track.scrollWidth <= track.clientWidth + 1);
    }

    function measure() {
      if (!track) return;
      metrics.max = Math.max(track.scrollWidth - track.clientWidth, 0);
      section.classList.toggle('m2vc--nobar', metrics.max <= 1);
      if (thumb && bar) {
        var ratio = track.clientWidth / (track.scrollWidth || 1);
        thumb.style.width = Math.min(Math.max(ratio * 100, 8), 100) + '%';
        metrics.barW = bar.clientWidth;
        metrics.thumbW = thumb.clientWidth;
      }
      render();
    }

    function render() {
      if (!track || !thumb) return;
      if (metrics.max <= 0) {
        thumb.style.transform = 'translateX(0)';
        thumb.setAttribute('aria-valuenow', '0');
        return;
      }
      var p = track.scrollLeft / metrics.max;
      var span = metrics.barW - metrics.thumbW;
      thumb.style.transform = 'translateX(' + (p * (span > 0 ? span : 0)) + 'px)';
      thumb.setAttribute('aria-valuenow', String(Math.round(p * 100)));
    }

    if (track) {
      on(track, 'scroll', function () {
        if (rafId) return;
        rafId = requestAnimationFrame(function () { rafId = null; render(); });
      }, { passive: true });
    }

    /* Drag via Pointer Events: works with mouse, touch and pen.
       Move/up listeners exist only while dragging. */
    if (thumb && track) {
      var dragging = false;
      var startX = 0;
      var startScroll = 0;

      var onMove = function (e) {
        if (!dragging) return;
        var span = metrics.barW - metrics.thumbW;
        if (span <= 0) return;
        track.scrollLeft = startScroll + ((e.clientX - startX) / span) * metrics.max;
      };
      var onUp = function () {
        if (!dragging) return;
        dragging = false;
        thumb.classList.remove('is-dragging');
        track.style.scrollBehavior = '';
        document.body.style.userSelect = '';
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
      };

      on(thumb, 'pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        thumb.classList.add('is-dragging');
        track.style.scrollBehavior = 'auto';
        document.body.style.userSelect = 'none';
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
        e.preventDefault();
      });
      cleanup.push(onUp);

      on(thumb, 'keydown', function (e) {
        var card = track.querySelector('.m2vc-card');
        var step = card ? card.offsetWidth + GAP : 300;
        if (e.key === 'ArrowRight') { track.scrollBy({ left: step, behavior: 'smooth' }); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step, behavior: 'smooth' }); e.preventDefault(); }
        else if (e.key === 'Home') { track.scrollTo({ left: 0, behavior: 'smooth' }); e.preventDefault(); }
        else if (e.key === 'End') { track.scrollTo({ left: metrics.max, behavior: 'smooth' }); e.preventDefault(); }
      });
    }

    if ('ResizeObserver' in window && track) {
      var ro = new ResizeObserver(function () { updateAlignment(); measure(); });
      ro.observe(track);
      cleanup.push(function () { ro.disconnect(); });
    } else {
      var timer;
      on(window, 'resize', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { updateAlignment(); measure(); }, 150);
      });
    }

    /* Videos are kept inside a <template> so the browser downloads nothing
       (no poster, no metadata) until the shopper actually presses play. */
    var medias = section.querySelectorAll('[data-m2vc-media]');

    Array.prototype.forEach.call(medias, function (media) {
      var playBtn = media.querySelector('[data-m2vc-play]');
      var holder = media.querySelector('[data-m2vc-video-holder]');
      var tpl = media.querySelector('[data-m2vc-video-tpl]');
      if (!playBtn || !holder || !tpl) return;

      playBtn.addEventListener('click', function () {
        var video = holder.querySelector('video');

        if (!video) {
          holder.appendChild(tpl.content.cloneNode(true));
          video = holder.querySelector('video');
          if (!video) return;
          video.removeAttribute('poster');
          video.setAttribute('preload', 'auto');
          video.setAttribute('playsinline', '');
          video.addEventListener('pause', function () { media.classList.remove('is-playing'); });
          video.addEventListener('ended', function () { media.classList.remove('is-playing'); });
        }

        media.classList.add('is-playing');
        video.controls = true;
        video.muted = false;
        var promise = video.play();
        if (promise !== undefined) { promise.catch(function () {}); }
      });
    });

    /* Pause anything that leaves the viewport. Using the viewport as root
       covers both cases: scrolling the carousel sideways and scrolling the
       page away while a video is playing. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          var v = entry.target.querySelector('video');
          if (v && !v.paused) v.pause();
        });
      }, { threshold: 0.25 });
      Array.prototype.forEach.call(medias, function (m) { io.observe(m); });
      cleanup.push(function () { io.disconnect(); });
    }

    updateAlignment();
    measure();

    section.m2vcCleanup = function () {
      cleanup.forEach(function (fn) { fn(); });
      cleanup = [];
    };
  }

  function initAll(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.m2vc-section'), function (section) {
      if (section.dataset.m2vcInitialized === 'true') return;
      section.dataset.m2vcInitialized = 'true';
      initCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.m2vc-section');
    if (!section) return;
    if (section.m2vcCleanup) section.m2vcCleanup();
    section.dataset.m2vcInitialized = '';
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.m2vc-section');
    if (section && section.m2vcCleanup) section.m2vcCleanup();
  });
})();
